import * as React from 'react';
import * as styles from './promoLink.css';

interface IPromoLink {
  text: string;
  onClick(event: React.MouseEvent<HTMLElement>): void;
}

export const PromoLink = ({ text, onClick }: IPromoLink) => {
  return (
    <div className={styles['link']} onClick={onClick}>
      {text}
    </div>
  );
};
